// extracted by mini-css-extract-plugin
export default {"main_wrapper":"app_main_wrapper__p3qxs","wrapper":"app_wrapper__P1qXk"};